import PrakerjaLandingPage from '../pages/PrakerjaLandingPage.vue';
const PrakerjaMerchantListPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaMerchantListPage" */ '../pages/PrakerjaMerchantListPage.vue');
const PrakerjaMerchantDetailPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaMerchantDetailPage" */ '../pages/PrakerjaMerchantDetailPage.vue');
const PrakerjaSearchPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaSearchPage" */ '../pages/PrakerjaSearchPage.vue');
const PrakerjaDetailPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaDetailPage" */ '../pages/PrakerjaDetailPage.vue');
const PrakerjaTermsAndConditionPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaTermsAndConditionPage" */ '../pages/PrakerjaTermsAndConditionPage.vue');
const PrakerjaCheckoutFormPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaCheckoutFormPage" */ '../pages/PrakerjaCheckoutFormPage.vue');
const PrakerjaAccountVerificationPage = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaAccountVerificationPage" */ '../pages/PrakerjaAccountVerificationPage.vue'
  );
const PrakerjaCategoryListPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaCategoryListPage" */ '../pages/PrakerjaCategoryListPage.vue');
const PrakerjaCategoryDetailPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaCategoryDetailPage" */ '../pages/PrakerjaCategoryDetailPage.vue');
const PrakerjaCourseListPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaCourseListPage" */ '../pages/PrakerjaCourseListPage.vue');

const PrakerjaCoursesFilter = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaCoursesFilter" */ '../components/PrakerjaSearchPage/PrakerjaCoursesFilter.vue'
  );
const PrakerjaCoursesSort = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaCoursesSort" */ '../components/PrakerjaSearchPage/PrakerjaCoursesSort.vue'
  );
const PrakerjaCoursesLocation = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaCoursesLocation" */ '../components/PrakerjaSearchPage/PrakerjaCoursesLocation.vue'
  );
const PrakerjaKelasTerdekatPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaKelasTerdekatPage" */ '../pages/PrakerjaKelasTerdekatPage.vue');
const PrakerjaFaqPage = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaFaqPage" */ '../pages/PrakerjaFaqPage.vue');
const PrakerjaFaqDetailPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaFaqDetailPage" */ '../pages/PrakerjaFaqDetailPage.vue');

const PrakerjaTransactionListPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaTransactionListPage" */ '../pages/PrakerjaTransactionListPage.vue');

const PrakerjaTransactionDetailPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaTransactionDetailPage" */ '../pages/PrakerjaTransactionDetailPage.vue');

const PrakerjaGamificationHomePage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaGamificationHomePage" */ '../pages/PrakerjaGamificationHomePage.vue');

const PrakerjaGamificationClaimPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "PrakerjaGamificationClaimPage" */ '../pages/PrakerjaGamificationClaimPage.vue');

const routes = [
  {
    name: 'landing',
    path: '/',
    component: PrakerjaLandingPage,
  },
  {
    name: 'search',
    path: '/pencarian',
    component: PrakerjaSearchPage,
    children: [
      {
        name: 'search-filter',
        path: 'filter',
        component: PrakerjaCoursesFilter,
      },
      {
        name: 'search-sort',
        path: 'sort',
        component: PrakerjaCoursesSort,
      },
      {
        name: 'search-location',
        path: 'location',
        component: PrakerjaCoursesLocation,
      },
    ],
  },
  {
    name: 'dynamic-section',
    path: '/section/:section_category/:section_slug',
    component: PrakerjaCourseListPage,
  },
  {
    name: 'merchants',
    path: '/lembaga',
    component: PrakerjaMerchantListPage,
  },
  {
    name: 'tnc',
    path: '/tnc',
    component: PrakerjaTermsAndConditionPage,
  },
  {
    name: 'checkout-form',
    path: '/checkout',
    component: PrakerjaCheckoutFormPage,
  },
  {
    name: 'account-verification',
    path: '/otp',
    component: PrakerjaAccountVerificationPage,
  },
  {
    name: 'categories',
    path: '/kategori',
    component: PrakerjaCategoryListPage,
  },
  {
    name: 'category',
    path: '/kategori/:id',
    component: PrakerjaCategoryDetailPage,
  },
  {
    name: 'merchant',
    path: '/lembaga/:id',
    component: PrakerjaMerchantDetailPage,
    children: [
      {
        name: 'merchant-search-filter',
        path: 'filter',
        component: PrakerjaCoursesFilter,
      },
      {
        name: 'merchant-search-sort',
        path: 'sort',
        component: PrakerjaCoursesSort,
      },
      {
        name: 'merchant-search-location',
        path: 'location',
        component: PrakerjaCoursesLocation,
      },
    ],
  },
  {
    name: 'closest-course',
    path: '/kelas-terdekat',
    component: PrakerjaKelasTerdekatPage,
  },
  {
    name: 'faq',
    path: '/faq',
    component: PrakerjaFaqPage,
  },
  {
    name: 'faq-detail',
    path: '/faq/:slug',
    component: PrakerjaFaqDetailPage,
  },
  {
    name: 'transaksi',
    path: '/transaksi',
    component: PrakerjaTransactionListPage,
  },
  {
    name: 'detail-transaksi',
    path: '/transaksi/:id',
    component: PrakerjaTransactionDetailPage,
  },
  {
    name: 'gamification',
    path: '/gamification',
    component: PrakerjaGamificationHomePage,
  },
  {
    name: 'gamification-claim',
    path: '/gamification/claim/:missionId',
    component: PrakerjaGamificationClaimPage,
  },
  {
    name: 'detail',
    path: '/:id',
    component: PrakerjaDetailPage,
  },
  {
    path: '*',
    redirect: '/',
  },
];

export default routes;
